// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TabsTokens } from './type';

const tabsTokens: TabsTokens = {
  tabsExtraFillHoverBackgroundColor: 'Neutral-fill-3',
  tabsCardDisabledBackgroundColor: 'Neutral-fill-2',
  tabsArrowFontColor: 'Neutral-text-4',
  tabsFontColor: 'Neutral-text-5',
  tabsBackgroundColor: 'Neutral-fill-2',
  tabsBorderColor: 'Neutral-border-1',
  tabsActiveFontColor: 'Brand-6',
  tabsActiveBackgroundColor: 'Neutral-fill-1',
  tabsHoverBackgroundColor: 'Neutral-fill-2',
  tabsDisabledFontColor: 'Neutral-text-2',
  tabsDisabledBackgroundColor: 'Neutral-fill-1',
  tabsClickBackgroundColor: 'Neutral-fill-4',
  tabsTabPaddingX: 'Padding-15',
  tabsTabPaddingY: 'Padding-9',
  tabsTabFontSize: '14/regular',
  tabsTabBorderRadius: 'Radius-4',
  tabsNearlyMargin: 'Margin-4',
  tabsLinePaddingX: 'Padding-8',
  tabsLinePaddingY: 'Padding-6',
  tabsLineInnerPaddingX: 'Padding-8',
  tabsLineInnerPaddingY: 'Padding-4',
  tabsFillPaddingX: 'Padding-4',
  tabsFillPaddingY: 'Padding-4',
  tabsFillInnerPaddingX: 'Padding-16',
  tabsFillInnerPaddingY: 'Padding-5',
  tabsSplitBorderColor: 'Neutral-border-2',
  tabsActionVerticalPaddingX: 'Padding-7',
  tabsActionVerticalPaddingY: 'Padding-4',
  tabsActionHorizontalPaddingX: 'Padding-7',
  tabsActionHorizontalPaddingY: 'Padding-8',
};

export default tabsTokens;
